import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { NavbarComponent } from '../../shared/components/navbar/navbar.component';
import { AuthService } from '../../core/services/auth-service/auth.service';
import { CommonModule } from '@angular/common';
import { SidebarGroupComponent } from '../../shared/components/sidebar-group/sidebar-group.component';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { SidebarService } from '../../core/services/sidebar/sidebar.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterModule,
    SidebarComponent,
    NavbarComponent,
    CommonModule,
    SidebarGroupComponent,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  breakpointMdScreen: number = 0;
  isOpenSideBar: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private authSrv: AuthService,
    private sidebarSrv: SidebarService
  ) {}

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    const sidebarWidth: number = 264;
    const padding: number = 48;
    this.breakpointMdScreen = window.innerWidth - sidebarWidth - padding;
  }

  ngOnInit(): void {
    this.onWindowResize();

    if (!this.isAuthenticated()) {
      this.router.navigateByUrl('/unauthorized');
      return;
    }else {
      this.handleNavigation();

      this.sidebarSrv.isOpenSideBar$
        .pipe(takeUntil(this.destroy$))
        .subscribe((state) => {
          this.isOpenSideBar =
            window.innerWidth < 480 ? state : this.isOpenSideBar;
        });
      }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private isAuthenticated(): boolean {
    return (
      !!this.authSrv.getAccessToken() ||
      !!sessionStorage.getItem('access_token')
    );
  }

  private async getResolvedDefaultPath(): Promise<string> {
    const path = await firstValueFrom(this.authSrv.currentDefaultPath$);
    return path;
  }

  private async handleNavigation(): Promise<void> {
    const currentUrl = this.router.url;
    const path = await this.getResolvedDefaultPath();

    if (currentUrl === '/' || currentUrl.includes('/?ID=') || currentUrl.includes('/?token=')) {
      this.navigateTo('/');
    }
  }

  private navigateTo(route: string): void {
    this.router.navigateByUrl(route, { replaceUrl: true });
  }
}
